const restclient = require('nordic/restclient');

const request = restclient({
  timeout: 5000,
  baseURL: '/developers/api/chat-ai',
});

export async function getConfigFromAPI(overrides = {}) {
  try {
    const response = await request.get('/get-config', {
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response
      || !response.data?.aiConfigServiceOk
      || !response?.data?.config?.setup?.nodeId
      || !response?.data?.config?.setup?.skill?.name
    ) {
      return null;
    }

    return Object.assign(response.data.config, overrides);
  } catch (error) {
    console.error('Error fetching config from verdi-config endpoint: ', error);
    return null;
  }
}
